// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import configs from '../configs';
import { IntegrationLayout, OAuthSetup, ExternalLinkA } from '../_shared';

class SalesforceMarketingCloud extends Component {
  componentDidMount() {
    this.props.store.integrations.SalesforceMarketingCloud.getConfigs();
    const { code, partner, tssd } = this.props.store.initQueryParams;
    if (partner === 'salesforcemarketingcloud' && code) {
      this.props.store.integrations.SalesforceMarketingCloud.verifyCode(code, tssd);
    }
  }

  render() {
    return (
      <IntegrationLayout config={configs.SalesforceMarketingCloud}>
        <OAuthSetup
          partnerKey="SalesforceMarketingCloud"
          steps={[
            <>Make a Salesforce Marketing Cloud account <ExternalLinkA href="https://www.salesforce.com/form/signup/freetrial-elf-v2/">here</ExternalLinkA> if you don&apos;t have one already.</>,
            'Grant Movology the necessary permissions:',
            'Future captures will be added as Salesforce leads.',
          ]}
        />
      </IntegrationLayout>
    );
  }
}

export default inject('store')(observer(SalesforceMarketingCloud));
